export default __webpack_public_path__ + "static/media/offers.cb260ee2.svg";